import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  style: {"width":"100%"},
  class: "overflow-auto px-16px pt-16px pb-16px"
}
const _hoisted_2 = { class: "search flex items-center gap-4px" }
const _hoisted_3 = { class: "categry" }
const _hoisted_4 = { class: "category" }
const _hoisted_5 = { class: "templatelist" }

import { ref } from 'vue'
import { ElInput, ElButton, ElCascader } from 'element-plus'

import { Search } from '@element-plus/icons-vue'
import { getCategories, recommendations } from '@/api/affairs'
import { onMounted } from 'vue'
// @ts-ignore
import TemplateItem from './TemplateItem.vue'
// @ts-ignore
import categoryTemplate from './categoryTemplate.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'template',
  props: {
    type: {}
  },
  setup(__props: any) {

const menuList = ref([])
const props = __props
onMounted(() => {

  getCategories({ type: props.type == 'team' ? 2 : 1, category_type: 1 }).then(res => {
    menuList.value = res.data.data
  })
  getList()
})
const curTab = ref(0)
const cascaderValue = ref([])
const searchValue = ref('')
const categoryName = ref('分类')
const cascaderRef = ref()
const categoryTemplateRef = ref()
const handleChange = (val) => {
  const info = cascaderRef.value?.getCheckedNodes()[0]?.data
  categoryName.value = info.name
  curTab.value = 1
  if (info.id) {
    categoryTemplateRef.value.searchTemplates(info.id, searchValue.value)
    // console.log(info.id, searchValue.value)
  }
}
const handleSearch = () => {
  curTab.value = 1
  categoryName.value = '分类'
  cascaderValue.value = []
  categoryTemplateRef.value.searchTemplates('', searchValue.value)
}
const handleRecommend = () => {
  categoryName.value = '分类'
  cascaderValue.value = []
  curTab.value = 0
}
const templateItems = ref([])

const getList = () => {
  recommendations({ hotType: 1, size: 20, type: 1 }).then((res) => {
    const data = res.data.data
    templateItems.value = data
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ElInput), {
        modelValue: searchValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
        placeholder: "请输入搜索内容",
        clearable: "",
        "prefix-icon": _unref(Search),
        style: {"margin-right":"16px"}
      }, null, 8, ["modelValue", "prefix-icon"]),
      _createVNode(_unref(ElButton), {
        type: "primary",
        onClick: handleSearch,
        style: {"background-color":"#2a66ff"}
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode("搜索", -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        onClick: handleRecommend,
        class: _normalizeClass(curTab.value === 0 ? 'select-bg' : '')
      }, "推荐", 2),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["category-title", curTab.value === 1 ? 'select-bg' : ''])
        }, _toDisplayString(categoryName.value), 3),
        _createVNode(_unref(ElCascader), {
          style: {"width":"120px","border":"none","opacity":"0","position":"absolute","top":"0","left":"0"},
          modelValue: cascaderValue.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((cascaderValue).value = $event)),
          onChange: handleChange,
          id: "category",
          ref_key: "cascaderRef",
          ref: cascaderRef,
          options: menuList.value,
          props: {
            value: 'id',
            label: 'name',
            children: 'children'
          },
          "show-all-levels": false,
          clearable: "",
          placeholder: "请选择分类"
        }, null, 8, ["modelValue", "options"])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templateItems.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "list",
          key: item.id
        }, [
          _createVNode(TemplateItem, { template: item }, null, 8, ["template"])
        ]))
      }), 128))
    ], 512), [
      [_vShow, curTab.value == 0]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(categoryTemplate, {
        ref_key: "categoryTemplateRef",
        ref: categoryTemplateRef
      }, null, 512)
    ], 512), [
      [_vShow, curTab.value == 1]
    ])
  ]))
}
}

})